<template>
  <div id="app" v-if="fronteggLoaded">
    <router-view />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useFrontegg, useFronteggAuthGuard } from "@frontegg/vue";
import { PUBLIC_ROUTES } from "@/constants/routes";

export default defineComponent({
  name: "App",
  setup() {
    const { fronteggLoaded, authState } = useFrontegg();

    if (!PUBLIC_ROUTES.includes(window.location.pathname)) {
      useFronteggAuthGuard();
    }
    return {
      fronteggLoaded,
      authState,
    };
  },
});
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
